import { defineStore } from 'pinia'
import Api from '../api/Api'

export const useApiClientStore = defineStore('apiClient', {
  state: () => ({
    clients: [],
    loading: false,
  }),
  getters: {
    getClients: function(state) {
      return state.clients;
    },
    getClientByUserId: function(state) {
      return (userId) => state.clients.find(c => c.user_id === userId);
    },
    isLoading: function(state) {
      return state.loading;
    }
  },
  actions: {
    async fetchClients(payload) {
      this.loading = true;
      try {
        const data = await Api.apiclient.getClients(payload);

        this.clients = data;
        return data;
      } finally {
        this.loading = false;
      }
    },

    async createClient(payload) {
      const result = await Api.apiclient.createClient(payload);
      this.clients.unshift(result);
      return result;
    },

    async deleteClient(payload) {
      await Api.apiclient.deleteClient(payload);
      this.clients = this.clients.filter(c => c.id !== payload.clientId);
    },

    async updateStatus(clientId, active, nodeId) {
      const response = await Api.apiclient.updateClientStatus({ clientId, active, nodeId });
      const index = this.clients.findIndex(c => c.id === clientId);
      if (index >= 0) {
        this.clients[index] = { ...this.clients[index], active };
      }
      return response.data.data;
    },

    async getClient(clientId, nodeId) {
      const data = await Api.apiclient.getClient({ clientId, nodeId });
      return data;
    },

    async updateClient(clientId, data, nodeId) {
      const result = await Api.apiclient.updateClient({
        clientId,
        nodeId,
        ...data
      });

      // Update the client in local state
      const index = this.clients.findIndex(c => c.id === clientId);
      if (index >= 0) {
        this.clients[index] = { ...this.clients[index], ...result };
      }

      return result;
    },
  }
});
